import React from 'react';
import PropTypes from 'prop-types';
import SymbolDefs from 'otter_icons/symbol-defs.svg';

export default class Ottercon extends React.Component {
  static propTypes = {
    ottercon: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
  };

  render() {
    const { ottercon, size } = this.props;
    const sizeClass = size ? ` bo-icon-${size}` : '';

    return (
      <svg className={`bo-icon bo-icon-${ottercon}${sizeClass}`}>
        <use href={`${SymbolDefs}#bo-icon-${ottercon}`}></use>
      </svg>
    );
  }
}
